import { OptionValue } from '@/interfaces/optionValue';

import { EntityResource } from './entity.resource';
import { OptionValueFilterVariables } from './queryVariables/filters/filters';
import { OptionValueByCodeParams, OptionValueByCodeVariables } from './queryVariables/optionValue';

/**
 * Resource wartości opcji
 *
 * @export
 * @class OptionValueResource
 * @extends {EntityResource<OptionValue>}
 */
export class OptionValueResource extends EntityResource<OptionValue> {
  public getFields = {
    id: true,
    value: true,
    entityType: true,
    entityId: true,
    option: {
      id: true,
      code: true
    }
  };

  public listFields = {
    id: true,
    value: true,
    optionId: true
  };

  constructor() {
    super({
      entityName: 'optionValue'
    });
  }

  protected listVariables = OptionValueFilterVariables;

  /**
   * Pobiera wartość opcji po kodzie
   *
   * @param {string} code
   * @param {string} entityType
   * @param {string} entityId
   * @returns {Promise<OptionValue>}
   * @memberof OptionValueResource
   */
  public getByCode(code: string, entityType: string, entityId: string): Promise<OptionValue> {
    const query = this.prepareOptions({
      query: {
        __variables: OptionValueByCodeVariables,
        optionValueInhertiedByCode: { __args: OptionValueByCodeParams, ...this.getFields }
      }
    });
    return this.query({ query, variables: { code, entityType, entityId } }, 'optionValueInhertiedByCode');
  }
}

export const optionValueResource = new OptionValueResource();
